import { render, staticRenderFns } from "./QuoteEdit.vue?vue&type=template&id=4954f04e&"
import script from "./QuoteEdit.vue?vue&type=script&lang=js&"
export * from "./QuoteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports